export enum RegistrationType {
  Sproom = 'sproom',
  Nemhandel = 'nemhandel',
}
